import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'

import HomeBase from './views/home/Base'
import Home from './views/home/Home'
import DownloadLT from './views/home/DownloadLT'
import DownloadSC from './views/home/DownloadSC'

import Login from './views/Login'
import NotFound from './views/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: HomeBase,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: {
            title: '首頁',
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/resources',
      name: 'resources',
      component: HomeBase,
      redirect: {
        name: 'resources.lt',
      },
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'lt',
          name: 'resources.lt',
          component: DownloadLT,
          meta: {
            title: '大家說英語 教學資源',
            requiresAuth: true,
            level: {
              name: 'lt',
              label: '大家說英語'
            }
          }
        },
        {
          path: 'sc',
          name: 'resources.sc',
          component: DownloadSC,
          meta: {
            title: '空中英語教室 教學資源',
            requiresAuth: true,
            level: {
              name: 'sc',
              label: '空中英語教室'
            }
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登入',
        guestOnly: true,
        requiresAuth: false
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
      meta: {
        title: '找不到頁面'
      }
    },
  ]
})

router.beforeEach((to, from, next) => {

  // check local token
  store.dispatch('auth/checkTokenExists').then(() => {

    if (to.meta.guestOnly) {
      next({ name: 'home' })
      return
    }

    next()

  }).catch(() => {

    if (to.meta.requiresAuth) {
      next({ name: 'login' })
      return
    }

    next()
  })
})

// eslint-disable-next-line
router.afterEach((to, from) => {
  let title = to.meta.title

  if (typeof title === 'undefined') {
    document.title = '空英老師專區'
  } else {
    document.title = `${title} | 空英老師專區`
  }
})

export default router
